import { useEffect, useRef } from 'react'
//import gsap from 'gsap-trial'
//import DrawSVGPlugin from 'gsap-trial/DrawSVGPlugin'
import gsap from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import LogoW from '../../../assets/images/logo_Wil.png'
import './index.scss'

const Logo = () => {
  const bgRef = useRef()
  const outlineLogoRef = useRef()
  const solidLogoRef = useRef()

  useEffect(() => {
    gsap.registerPlugin(DrawSVGPlugin)

    gsap
      .timeline()
      .to(bgRef.current, {
        duration: 1,
        opacity: 1,
      })
      .from(outlineLogoRef.current, {
        drawSVG: 0,
        duration: 4,
      })

    gsap.fromTo(
      solidLogoRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        delay: 4,
        duration: 4,
      }
    )
  }, [])

  return (
    <div className="logo-container" ref={bgRef}>
      <img
        className="solid-logo"
        ref={solidLogoRef}
        src={LogoW}
        alt="W"
      />

      <svg
        width="1080.000000pt"
        height="1080.000000pt"
        version="1.0"
        viewBox="0 0 1080.000000 1080.000000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          className="svg-container"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
          fill="none"
        >
          <path
            ref={outlineLogoRef}
            d="M1190 10774 c0 -3 25 -81 55 -172 260 -794 565 -2204 720 -3327 64
            -469 125 -903 185 -1330 92 -647 184 -1297 249 -1765 135 -959 195 -1697 223
            -2760 11 -435 4 -928 -19 -1322 l-6 -98 1139 0 1140 0 37 258 c21 141 56 376
            78 522 22 146 53 357 70 470 28 194 78 530 189 1275 28 182 68 452 89 600 22
            149 58 389 80 535 44 290 125 834 226 1515 36 242 94 634 130 872 36 237 65
            434 65 438 0 3 28 5 62 3 l63 -3 7 -55 c4 -30 35 -235 68 -455 110 -731 140
            -937 190 -1275 27 -184 68 -456 90 -605 70 -471 159 -1061 200 -1340 23 -148
            61 -405 85 -570 44 -295 65 -441 185 -1240 90 -599 140 -937 140 -941 0 -2
            513 -4 1141 -4 l1141 0 -6 58 c-27 256 -36 1254 -16 1772 35 905 102 1709 195
            2325 19 127 62 417 95 645 33 228 90 615 126 860 111 765 163 1123 215 1499
            172 1249 455 2578 729 3419 33 100 60 187 60 192 0 7 -405 10 -1136 10 l-1137
            0 7 -87 c4 -49 11 -142 16 -208 43 -564 37 -1497 -15 -2340 -34 -539 -103
            -1187 -175 -1643 -59 -378 -126 -809 -181 -1172 -22 -146 -51 -334 -65 -419
            -13 -85 -40 -294 -60 -465 -19 -171 -44 -368 -54 -438 -11 -70 -20 -129 -20
            -132 0 -3 -24 -6 -54 -6 -43 0 -56 4 -60 18 -3 9 -32 204 -65 432 -34 228 -95
            647 -136 930 -42 283 -98 668 -125 855 -27 187 -65 444 -84 570 -20 127 -53
            354 -75 505 -37 255 -69 474 -232 1585 -122 833 -190 1299 -241 1653 l-52 362
            -737 0 -738 0 -10 -52 c-6 -29 -31 -188 -56 -353 -25 -165 -68 -444 -95 -620
            -58 -373 -117 -756 -166 -1080 -19 -126 -59 -387 -89 -580 -29 -192 -81 -528
            -114 -745 -34 -217 -88 -570 -121 -785 -33 -214 -62 -406 -65 -425 -3 -19 -32
            -208 -64 -420 -33 -212 -87 -563 -120 -780 -33 -217 -81 -528 -106 -690 -25
            -162 -48 -314 -52 -338 l-6 -42 -63 0 c-58 0 -64 2 -69 23 -11 52 -37 252 -70
            532 -19 165 -62 485 -95 710 -33 226 -89 610 -124 855 -36 245 -81 549 -100
            675 -75 495 -142 1250 -178 2010 -16 342 -16 1352 0 1605 14 228 30 434 37
            473 l5 27 -1140 0 c-627 0 -1140 -3 -1140 -6z"
          />
        </g>
      </svg>
    </div>
  )
}

export default Logo
